import React, {useEffect, useState} from "react";
import API from 'libs/api';
import {Button} from "semantic-ui-react";
import { useNavigate } from 'react-router-dom';
import {CHIPS, INPUT, TEXTAREA } from "components/cmp_form/cmp_form";
import ICON from 'components/cmp_icon/cmp_icon'
import CMP_CONFIRMATION from "components/cmp_confirmation/cmp_confirmation";
import PROCESSING from "components/cmp_processing/cmp_processing";

import './crd_details.css';



export default function CRD_DETAILS({ current_tab, provider_id, set_provider_name }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const navigate = useNavigate();

    const [var_status, set_status] = useState({});
    const [var_details, set_details] = useState({});
    const [var_descriptions, set_descriptions] = useState({});
    const [var_socialmedia, set_socialmedia] = useState({});
    const [var_statusLoading, set_statusLoading] = useState(false);
    const [var_detailsLoading, set_detailsLoading] = useState(false);
    const [var_descriptionsLoading, set_descriptionsLoading] = useState(false);
    const [var_socialmediaLoading, set_socialmediaLoading] = useState(false);
    const [var_statusProcessing, set_statusProcessing] = useState('inactive');
    const [var_detailsProcessing, set_detailsProcessing] = useState('inactive');
    const [var_descriptionsProcessing, set_descriptionsProcessing] = useState('inactive');
    const [var_socialmediaProcessing, set_socialmediaProcessing] = useState('inactive');

    //  delete provider
    const [ var_deleteProvider_open, set_deleteProvider_open ] = useState(false);
    const [ var_deleteStatus, set_deleteStatus ] = useState('inactive')



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        get_details();
        get_descriptions();
        get_socialmedia();
    }, [provider_id]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function delete_provider() {

        set_deleteStatus('processing');

        try {
            let results = await API_delete_provider();
            set_deleteProvider_open(false);
            navigate('/providers');
        } catch (e) {
            console.log(e)
            set_deleteStatus('error');
        }
    }

    async function get_details() {

        set_detailsLoading(true);
        set_detailsProcessing('processing');

        try {
            let results = await API_get_details();
            set_details(results);
            set_provider_name(results.name);
            set_detailsProcessing('inactive');
            set_detailsLoading(false);
        } catch (e) {
            set_detailsProcessing('error');
        }
    }

    async function get_descriptions() {

        set_descriptionsLoading(true);
        set_descriptionsProcessing('processing');

        try {
            let results = await API_get_descriptions();
            set_descriptions(results);
            set_descriptionsProcessing('inactive');
            set_descriptionsLoading(false);
        } catch (e) {
            set_descriptionsProcessing('error');
        }
    }

    async function get_socialmedia() {

        set_socialmediaLoading(true);
        set_socialmediaProcessing('processing');

        try {
            let results = await API_get_socialmedia();
            set_socialmedia(results);
            set_socialmediaProcessing('inactive');
            set_socialmediaLoading(false);
        } catch (e) {
            set_socialmediaProcessing('error');
        }
    }

    async function put_details() {

        set_detailsLoading(true);
        set_detailsProcessing('processing');

        try {
            await API_put_details();
            await get_details();
        } catch (e) {
            set_detailsProcessing('error');
        }
    }

    async function put_descriptions() {

        set_descriptionsLoading(true);
        set_descriptionsProcessing('processing');

        try {
            await API_put_descriptions();
            await get_descriptions();
        } catch (e) {
            set_descriptionsProcessing('error');
        }
    }

    async function put_socialmedia() {

        set_socialmediaLoading(true);
        set_socialmediaProcessing('processing');

        try {
            await API_put_socialmedia();
            await get_socialmedia();
        } catch (e) {
            set_socialmediaProcessing('error');
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_delete_provider() {
        return API.del('admin-providers', '/delete-provider/' + provider_id);
    }

    function API_get_details() {
        return API.get('admin-providers', '/get-details/' + provider_id);
    }

    function API_get_descriptions() {
        return API.get('admin-providers', '/get-descriptions/' + provider_id);
    }

    function API_get_socialmedia() {
        return API.get('admin-providers', '/get-socialmedia/' + provider_id);
    }

    function API_put_details() {
        return API.put('admin-providers', '/put-details/', {body: var_details});
    }

    function API_put_descriptions() {
        return API.put('admin-providers', '/put-descriptions/', {body: var_descriptions});
    }

    function API_put_socialmedia() {
        return API.put('admin-providers', '/put-socialmedia/', {body: var_socialmedia});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_status(event) {
        let details = {...var_details};
        details.status = event;
        set_details(details);
    }

    function onChange_reviewed(event) {
        let details = {...var_details};
        details.reviewed = event;
        set_details(details);
    }

    function onChange_details(event) {
        let details = {...var_details};
        details[event.target.name] = event.target.value;
        set_details(details);
    }

    function onChange_descriptions(event) {
        let descriptions = {...var_descriptions};
        descriptions[event.target.name] = event.target.value;
        set_descriptions(descriptions);
    }

    function onChange_socialmedia(event) {
        let socialmedia = {...var_socialmedia};
        socialmedia[event.target.name] = event.target.value;
        set_socialmedia(socialmedia);
    }

    function onClick_host() {
        var_details.host.toLowerCase().startsWith('https') ? window.open(var_details.host) : window.open('https://' + var_details.host);
    }

    function onClick_deleteProvider() {
        set_deleteStatus('inactive');
        set_deleteProvider_open(true);
    }

    function onClick_facebook() {
        window.open(var_socialmedia.facebook);
    }

    function onClick_instagram() {
        window.open(var_socialmedia.instagram);
    }

    function onClick_cancelDetails() {
        if (!var_detailsLoading) {
            get_details();
        }
    }

    function onClick_updateDetails() {
        if (!var_detailsLoading) {
            put_details();
        }
    }

    function onClick_cancelDescriptions() {
        if (!var_descriptionsLoading) {
            get_descriptions();
        }
    }

    function onClick_updateDescriptions() {
        if (!var_descriptionsLoading) {
            put_descriptions();
        }
    }

    function onClick_cancelSocialmedia() {
        if (!var_socialmediaLoading) {
            get_socialmedia();
        }
    }

    function onClick_updateSocialmedia() {
        if (!var_socialmediaLoading) {
            put_socialmedia();
        }
    }

    function onClick_confirmDeleteProvider() {
        set_deleteStatus('processing')
        delete_provider()
    }



    // RENDER CONTAINER ================================================================================================

    return (

        <div id='provider--tab--details'>

            <div className='navigation__sidebar'>
                <div className='navigation__sidebar__item '>Basic information</div>
                <div className='navigation__sidebar__item '>Descriptions</div>
                <div className='navigation__sidebar__item '>Social media</div>
            </div>

            <div className='content__sidebar'>

                <div id='crd_provider_details' className='card '>
                    <div className='card__header'>
                        <div className='text--md bold'>Basic information</div>
                        <div className='text--sm color--gray--600'>Basic provider details and display options</div>
                    </div>
                    <div className='card__content'>

                        <CHIPS
                            label={'Reviewed'}
                            onChange={onChange_reviewed}
                            options={[
                                { value: 'YES', text: 'Yes' },
                                { value: null, text: 'No' },
                            ]}
                            value={var_details.reviewed}
                        />

                        <CHIPS
                            label={'Display status'}
                            onChange={onChange_status}
                            options={[
                                { value: 'PUBLISHED', text: 'Published' },
                                { value: 'UNPUBLISHED', text: 'Unpublished' },
                            ]}
                            value={var_details.status}
                        />

                        <INPUT
                            description='The provider name as it should appear in Lively Village'
                            errors={[]}
                            label='Name'
                            name='name'
                            onChange={onChange_details}
                            placeholder='Provider name'
                            value={var_details.name || null}
                        />

                        <INPUT
                            description="The unique identifier of the Lively Village provider's page"
                            errors={[]}
                            label='Slug'
                            name='slug'
                            onChange={onChange_details}
                            placeholder='Slug'
                            value={var_details.slug || null}
                        />

                        <INPUT
                            action={{
                                icon: <ICON name='link' className='action__icon' alt='link icon'/>,
                                onClick: () => onClick_host()
                            }}
                            description="The URL of the provider's website"
                            errors={[]}
                            label='Domain'
                            name='host'
                            onChange={onChange_details}
                            placeholder='Domain'
                            value={var_details.host || null}
                        />

                    </div>

                    <PROCESSING state={var_detailsProcessing}/>

                    <div className='card__footer'>
                        <Button className={'primary' + (var_detailsLoading ? ' inactive' : '')} onClick={onClick_updateDetails}>Update</Button>
                        <Button className={'secondary' + (var_detailsLoading ? ' inactive' : '')} onClick={onClick_cancelDetails}>Cancel</Button>
                        <Button id='btn_delete' className='tertiary' onClick={onClick_deleteProvider}><ICON name='garbage' className='icon' alt='garbage icon'/>Delete provider</Button>
                    </div>
                </div>

                <div id='crd_provider_details' className='card '>
                    <div className='card__header'>
                        <div className='text--md bold'>Descriptions</div>
                        <div className='text--sm color--gray--600'>Provider on-page and meta SEO optimized descriptions</div>
                    </div>
                    <div className='card__content'>

                        <TEXTAREA
                            id='txt__description'
                            description='SEO optimized description that appears on the provider page'
                            errors={[]}
                            label='Description'
                            maxLength='1000'
                            name='description'
                            onChange={onChange_descriptions}
                            placeholder='Description'
                            value={var_descriptions.description || null}
                        />

                        <TEXTAREA
                            id='txt__description_meta'
                            description='The description that appears in search result pages'
                            errors={[]}
                            label='Meta description'
                            maxLength='200'
                            name='description_meta'
                            onChange={onChange_descriptions}
                            placeholder='Meta description'
                            value={var_descriptions.description_meta || null}
                        />

                    </div>

                    <PROCESSING state={var_descriptionsProcessing}/>

                    <div className='card__footer'>
                        <Button className={'primary' + (var_descriptionsLoading ? ' inactive' : '')} onClick={onClick_updateDescriptions}>Update</Button>
                        <Button className={'secondary' + (var_descriptionsLoading ? ' inactive' : '')} onClick={onClick_cancelDescriptions}>Cancel</Button>
                    </div>
                </div>

                <div id='crd_provider_details' className='card '>
                    <div className='card__header'>
                        <div className='text--md bold'>Social media</div>
                        <div className='text--sm color--gray--600'>Provider social media accounts</div>
                    </div>
                    <div className='card__content'>
                        <INPUT
                            action={{
                                icon: <ICON name='link' className='action__icon' alt='link icon'/>,
                                onClick: () => onClick_facebook()
                            }}
                            description="The URL to the provider's Facebook page"
                            errors={[]}
                            label='Facebook'
                            name='facebook'
                            onChange={onChange_socialmedia}
                            placeholder='Facebook'
                            value={var_socialmedia.facebook || null}
                        />

                        <INPUT
                            action={{
                                icon: <ICON name='link' className='action__icon' alt='link icon'/>,
                                onClick: () => onClick_instagram()
                            }}
                            description="The URL to the provider's Instagram page"
                            errors={[]}
                            label='Instagram'
                            name='instagram'
                            onChange={onChange_socialmedia}
                            placeholder='Instagram'
                            value={var_socialmedia.instagram || null}
                        />

                    </div>

                    <PROCESSING state={var_socialmediaProcessing}/>

                    <div className='card__footer'>
                        <Button className={'primary' + (var_socialmediaLoading ? ' inactive' : '')} onClick={onClick_updateSocialmedia}>Update</Button>
                        <Button className={'secondary' + (var_socialmediaLoading ? ' inactive' : '')} onClick={onClick_cancelSocialmedia}>Cancel</Button>
                    </div>
                </div>

            </div>

            <CMP_CONFIRMATION
                onOpen={var_deleteProvider_open}
                onClose={() => set_deleteProvider_open(false)}
                confirmation_state='warning'
                confirmation_title={'Delete ' + var_details.name}
                confirmation_subtitle='Confirmation required before proceeding'
                text={"Deleting " + var_details.name + " will remove all of their details from the system. The website domain " + var_details.host + " will also be marked as 'not a provider'."}
                button_text='Delete'
                button_onClick={onClick_confirmDeleteProvider}
                processing_status={var_deleteStatus}
            />

        </div>
    )
}